<template>
  <v-container fluid class="mx-0 px-0">
      <v-row no-gutters class="mb-10">
        <v-col cols=12 justify="center" align="center" class="mx-0 my-0 px-0 py-0 hidden-md-and-down">
            <v-img
                width="100%"
                contain 
                :src="require('@/assets/members.jpg')">
            </v-img>
        </v-col>
      </v-row>
      <!-- <v-row class="page-gutter" no-gutters justify="center" align="center">
        <div v-for="(group, index) in vip" :key="index">
          <v-col v-if="index" cols=12 lg=4 justify="center" align="center">
            <v-btn
              rounded
              small
              color="#1b2f5a"
              dark
              @click="goTo(index)"
            >
              {{index}}
            </v-btn>
          </v-col>
        </div>
      </v-row> -->
      <v-btn
        v-scroll="onScroll"
        v-show="fab"
        fab
        dark
        fixed
        bottom
        right
        color="#1b2f5a"
        @click="toTop()"
      >
            <v-icon>mdi-chevron-up</v-icon>
      </v-btn>
      <section class="vip page-gutter">
        <section-title>VIP</section-title>
        <p class="vip__lead">Προσωπικότητες του αθλητισμού και του πολιτισμού που στηρίζουν το έργο του Π.Α.Ρ.Ο.Ν.</p>
        <div class="vip__grid">
          <div v-for="member in vip" :key="member.id" class="vip__member">
            <div class="vip__photo">
              <img
                v-if="member.image"
                :alt="member.firstName + ' ' + member.lastName"
                :src="getMemberImage(member)"
                loading="lazy"
              >
              <img v-else class="vip__placeholder" alt="" :src="getImage()">
            </div>
            <div class="vip__name">{{ member.firstName }} {{ member.lastName }}</div>
            <div v-if="member.profession" class="vip__role">{{ member.profession }}</div>
          </div>
        </div>
      </section>
  </v-container>
</template>


<script>
  import restApi from "@/rest-api";
  import SectionTitle from "@/components/SectionTitle.vue";

  export default {
    components: { SectionTitle },
    data() {
        return {
            vip: {},
            fab: false
        }
    },
    created() {
        this.fetchVip();
    },
    methods: {
      getImage() {
        return require('@/assets/LOGOPARON 2023.svg')
      },
      getMemberImage(member) {
        return restApi.imageUrl(member.image)
      },
      fetchVip() {
        var search = `/member/vip`;
        restApi
        .get(search)
        .then(response => {
              this.vip = response.data
              // this.vip = response.data.sort(
              //       (a,b) => a.lastName < b.lastName ? -1 : 1
              //   )
        })
        .catch((error) => {
            console.log(error);
        });
      },
      goTo(index) {
        this.$vuetify.goTo(this.$refs[index][0]);
      },
      onScroll (e) {
        if (typeof window === 'undefined') return
        const top = window.pageYOffset ||   e.target.scrollTop || 0
        this.fab = top > 20
      },
      toTop() {
        this.$vuetify.goTo(0)
      }
    }
  }
</script>

<style lang="scss" scoped>
    .vip {
      padding-bottom: 64px;
      color: #1b2f5a;
    }

    .vip__lead {
      max-width: 620px;
      margin: 12px auto 40px;
      text-align: center;
      font-size: 17px;
      color: rgba(27, 47, 90, 0.75);
    }

    .vip__grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
      gap: 40px 24px;
    }

    .vip__member {
      text-align: center;
    }

    .vip__photo {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 180px;
      height: 180px;
      margin: 0 auto 16px;
      border-radius: 50%;
      overflow: hidden;
      background: #1b2f5a;
      box-shadow: 0 0 0 4px #fff, 0 0 0 6px rgba(173, 40, 45, 0.5), 0 10px 24px rgba(27, 47, 90, 0.18);
      transition: transform 0.2s ease;
    }

    .vip__member:hover .vip__photo {
      transform: translateY(-4px);
    }

    .vip__photo img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .vip__photo img.vip__placeholder {
      width: 70%;
      height: auto;
      object-fit: contain;
    }

    .vip__name {
      font-size: 17px;
      font-weight: 700;
      line-height: 1.3;
    }

    .vip__role {
      margin-top: 4px;
      font-size: 14px;
      line-height: 1.4;
      color: rgba(27, 47, 90, 0.7);
    }

    @media (max-width: 599px) {
      .vip__grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 28px 12px;
      }

      .vip__photo {
        width: 128px;
        height: 128px;
      }

      .vip__name {
        font-size: 15px;
      }

      .vip__role {
        font-size: 13px;
      }
    }
</style>